import { render, staticRenderFns } from "./rename.vue?vue&type=template&id=f9657274&scoped=true"
import script from "./rename.vue?vue&type=script&lang=js"
export * from "./rename.vue?vue&type=script&lang=js"
import style0 from "./rename.vue?vue&type=style&index=0&id=f9657274&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9657274",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/c-webhlzfq_workbench-web_en_test/orca-ac-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9657274')) {
      api.createRecord('f9657274', component.options)
    } else {
      api.reload('f9657274', component.options)
    }
    module.hot.accept("./rename.vue?vue&type=template&id=f9657274&scoped=true", function () {
      api.rerender('f9657274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/dialog/rename.vue"
export default component.exports